import { type ReactNode } from 'react';

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export default function BottomSheet({ open, onClose, title, children }: BottomSheetProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/50 sheet-backdrop"
        onClick={onClose}
      />
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl sheet-slide-up max-h-[85vh] flex flex-col">
        <div className="flex justify-center pt-3 pb-1 shrink-0">
          <div className="w-10 h-1 rounded-full bg-brown-200" />
        </div>
        {title && (
          <div className="px-4 py-2 text-center text-brown-900 text-base font-bold shrink-0">
            {title}
          </div>
        )}
        <div className="overflow-y-auto pb-20">{children}</div>
      </div>
    </div>
  );
}